import React from "react";
import SemesterSubmissionConfirmation from "./SemesterSubmissionConfirmation";
import { Link } from "react-router-dom";
import generateUrlWithParams from "../../utils/generateUrlWithParams";
import { ACCOUNT_SCHEDULE_UPDATE_ROUTE } from "../../constants/routes/accountRoutes";

export default function CopySemesterSubmissionConfirmation({
  userEmail,
  semesterId,
  showAccountLink,
}) {
  return (
    <SemesterSubmissionConfirmation showAccountLink={showAccountLink}>
      <p>
        You're all set. We'll be sending you a weekly email chock full of
        resources that match the topic you're teaching the following week.
      </p>
      <p>Click below to review and edit your course schedule.</p>

      {userEmail && semesterId && (
        <Link
          className="link-btn"
          to={`${ACCOUNT_SCHEDULE_UPDATE_ROUTE}${generateUrlWithParams([
            { key: "semester", value: semesterId },
            { key: "email", value: userEmail },
          ])}`}
        >
          Review Schedule
        </Link>
      )}
    </SemesterSubmissionConfirmation>
  );
}
